import React from "react";

const AssessmentSettings = () => {
  return <div>Test Settings...</div>;
};

export default AssessmentSettings;
